import React, { Component } from "react";
import PatientDetails from "../EmployeeVisitContainer/EmployeeVisitDetailView/PatientDetails";
import VisitDetails from "../EmployeeVisitContainer/EmployeeVisitDetailView/VisitDetails";
// import RightContent from './RightContent';
import WithRouter from "../../hoc/WithRouter";
import WithRoutify from "../../hoc/WithRoutify";
import VisitsService from "../../services/VisitsService";
import EmployeeService from "../../services/EmployeeService";
import CompanyDetails from "../EmployeeVisitContainer/EmployeeVisitDetailView/CompanyDetails";
import { connect } from "react-redux";
import LookupService from "../../services/LookupService";
import InjuryIllnessDetails from "./InjuryIllnessDetails";
import { isSet } from "../../utils/commonUtils";
import AuthService from "../../services/AuthService";
import RightContent from "./RightContent";
import BodyComponent from "../../components/UI/BodyComponent";
import OrganComponent from "../../components/UI/OrganComponent";
import HumanSystem from "./HumanSystem";
import AddIncidentModal from "../EmployeeVisitContainer/AddIncidentModal";
import Buttons from "../../components/UI/Buttons";
import BreadCrumbs from "./NewUIEmrPage/BreadCrumbs";
import NewPatientDetails from "./NewUIEmrPage/NewPatientDetails";
import NewRightContent from "./NewUIEmrPage/NewRightContent";
import OrganSection from "./OrganSection";
import AIPrediction from "./AIPrediction";
import NewProviderDetails from "../EmployeeVisitContainer/NewEmployeeVisitDetailView/NewProviderDetails";
import NewAddLab from "./Tabs/OrdersAndResultsSection/NewAddLab";
import NewAddVaccine from "./Tabs/OrdersAndResultsSection/NewAddVaccine";
import IncidentService from "../../services/IncidentService";
import SendTaskModal from "../../components/Modal/SendTaskModal";
import { formatPhoneNumberUS } from "../../utils/commonUtils";

class NewEmrDetailView extends Component {
  constructor(props) {
    super(props);
    this.patientBtnRef = React.createRef();
    this.injuryBtnRef = React.createRef();
    this.companyBtnRef = React.createRef();
    this.patientPopoverRef = React.createRef();
    this.injuryPopoverRef = React.createRef();
    this.companyPopoverRef = React.createRef();
    this.state = {
      visitDetails: {},
      employeeId: null,
      employeeDetails: {},
      lookupsOptions: {},
      visitDetails: {},
      selectedBodyPart: [],
      isrenderICD:false,
      showIncident:false,
      isrenderIncident:false,
      AddLabToggle:false,
      isVaccineModelOpen:false,
      renderResults:false,
      activeEditId:null,
      form_id:'',
      visit_status:'',
      incident_id:null,
      incidentDetails: {}, // <-- ADDED: To store the full incident object
      timelineData: [], // Timeline data for LOS calculation
      assessmentRefreshTrigger: 0, // Trigger to refresh assessment form
      aiSuggestionsRefreshTrigger: 0, // Trigger to refresh AI suggestions
      chartingSendMessageOpen: false,
      chartingSendMessageNav: null,
      isLeftSidebarCollapsed: false,
      isPatientPopoverOpen: false,
      isInjuryPopoverOpen: false,
      isCompanyPopoverOpen: false,
    };
  }

  openSendMessageFromCharting = () => {
    const visitId = this.props.params?.visitId;
    const { Toast } = this.props;
    if (!visitId) {
      if (Toast && typeof Toast.error === "function") {
        Toast.error("No visit selected.");
      }
      return;
    }
    const loc = this.props.location || {};
    const nav = `${loc.pathname || ""}${loc.search || ""}`;
    this.setState({ chartingSendMessageOpen: true, chartingSendMessageNav: nav });
  };

  closeSendMessageFromCharting = () => {
    this.setState({ chartingSendMessageOpen: false, chartingSendMessageNav: null });
  };
  async componentDidMount() {
    // Code to run after the component has mounted
    this.fetchVisitList();
    // this.getIncidentById();
    this.fetchTimeline();
    this.getIncidentBodyPartChange()
    document.addEventListener("mousedown", this.handleGlobalMouseDown, true);
    // this.fetchLookups();
    // this.toggleSidebar();
  }
  toggleSidebar = () => {
    // document.body.classList.toggle("sidebar-toggled");
    // document.querySelector(".sidebar").classList.toggle("toggled");
    // if (document.querySelector(".sidebar").classList.contains("toggled")) {
    //   document
    //     .querySelectorAll(".sidebar .collapse")
    //     .forEach((el) => el.classList.remove("show"));
    // }
    const body = document.body;
    body.classList.add("sidebar-toggled");
  };
  componentDidUpdate(prevProps, prevState) {
    // Code to run after the component has updated
    if (prevState.employeeId != this.state.employeeId) {
      this.fetchEmployeeDetails(this.state.employeeId);
    }
    if (prevState.visit_status !== this.state.visit_status) {
      this.fetchVisitList();
      this.fetchTimeline(); // Refresh timeline when status changes
    }
  }
  // fetchLookups = async () => {
  //   const [chartResult, shippingService] = await Promise.all([
  //     LookupService.getLookupByKey("chart_result"),
  //     LookupService.getLookupByKey("shipping_service"),
  //   ]);
  //   let shippingServiceOptions = [{ label: "-None-", value: "" }];
  //   shippingService.forEach((item) => {
  //     shippingServiceOptions.push({
  //       label: item.value,
  //       value: item.value,
  //     });
  //   });
  //   let chartResultOptions = [{ label: "-None-", value: "" }];
  //   chartResult.forEach((item) => {
  //     chartResultOptions.push({
  //       label: item.value,
  //       value: item.value,
  //     });
  //   });
  //   this.setState({
  //     lookupsOptions: {
  //       shippingService: shippingServiceOptions,
  //       chartResult: chartResultOptions,
  //     },
  //   });
  //   //   console.log('shippingService',shippingService,chartResult);
  // };
  componentWillUnmount() {
    
   // const body = document.body;
   //body.classList.remove("sidebar-toggled");
    document.removeEventListener("mousedown", this.handleGlobalMouseDown, true);
  }

  isTabletWidth = () => {
    try {
      return window.matchMedia?.("(min-width: 768px) and (max-width: 1024px)")?.matches ?? false;
    } catch (e) {
      return false;
    }
  };
  isDesktopLarge = () => {
    try {
      return window.matchMedia?.("(min-width: 1025px)")?.matches ?? false;
    } catch (e) {
      return false;
    }
  };

  handleGlobalMouseDown = (e) => {
    if (!this.state.isPatientPopoverOpen && !this.state.isInjuryPopoverOpen && !this.state.isCompanyPopoverOpen) return;

    const target = e.target;

    const patientBtn = this.patientBtnRef?.current;
    const injuryBtn = this.injuryBtnRef?.current;
    const companyBtn = this.companyBtnRef?.current;
    const patientPopover = this.patientPopoverRef?.current;
    const injuryPopover = this.injuryPopoverRef?.current;
    const companyPopover = this.companyPopoverRef?.current;

    const clickedPatient = !!(patientBtn && patientBtn.contains(target)) || !!(patientPopover && patientPopover.contains(target));
    const clickedInjury = !!(injuryBtn && injuryBtn.contains(target)) || !!(injuryPopover && injuryPopover.contains(target));
    const clickedCompany = !!(companyBtn && companyBtn.contains(target)) || !!(companyPopover && companyPopover.contains(target));

    if (!clickedPatient && this.state.isPatientPopoverOpen) {
      this.setState({ isPatientPopoverOpen: false });
    }
    if (!clickedInjury && this.state.isInjuryPopoverOpen) {
      this.setState({ isInjuryPopoverOpen: false });
    }
    if (!clickedCompany && this.state.isCompanyPopoverOpen) {
      this.setState({ isCompanyPopoverOpen: false });
    }
  };
  // ToggleOrders=(form_id='')=>{
  //   this.setState({AddLabToggle:!this.state.AddLabToggle,form_id:form_id,activeEditId:form_id==""?"":this.state.activeEditId});
  // }
  HanndleIncidentBodyPartChange=async(parts)=>{    
    try{
      const payload={
        injury_locations:this.state.selectedBodyPart.length>0?this.state.selectedBodyPart.join(','):null,
        current_validation:'tab2',
        visit_id:this.props.params.visitId,

      }
      let res;
      if(this.state.incident_id){
        res= await IncidentService.updateIncidentById(this.state.incident_id,payload);
      } else {
        payload.relatedness = "";
        payload.incident_type = "Injury";
        payload.employer_phone = this.state.employeeDetails.company.phone;
        payload.employer_id = this.state.employeeDetails.company.company_uuid;
        payload.work_comp_insurance_tpa = this.state.employeeDetails.company.work_comp_insurance || "";
        payload.policy_number = this.state.employeeDetails.company.work_comp_policy_number || "";
        payload.work_comp_injury = this.state.employeeDetails.company.work_comp_insurance || "";
        res = await IncidentService.saveIncident(payload);
      }
      console.log('Incident body part update response:',res);
    }catch(err){
      console.error('Error in HanndleIncidentBodyPartChange:',err);
    } 
  }
  getIncidentBodyPartChange=async(val)=>{
    try{  
      const res= await IncidentService.getIncidentById(this.props.params.visitId);
      
      if(res){
      const organArray = isSet(res.injury_locations,"") !== "" ? res.injury_locations.split(',') : [];
      this.setState({selectedBodyPart:organArray,incident_id:res.incident_id,incidentDetails:res});
      }

    }catch(err){
      console.error('Error in HanndleIncidentBodyPartChange:',err);
    }
  }
  handleEvent = (val, selected) => {
    
    this.setState((prevState) => {
  let updatedParts = [...prevState.selectedBodyPart];

  if (selected) {
    if (!updatedParts.includes(val)) {
      updatedParts.push(val);
    }
  } else {
    updatedParts = updatedParts.filter((part) => part !== val);
  }

  console.log("render1");

  return {
    selectedBodyPart: updatedParts,
    isrenderICD: updatedParts
  };
},()=>this.HanndleIncidentBodyPartChange(this.state.selectedBodyPart));

  };
  incidentToogleHanlder=()=>{
    const wasOpen = this.state.showIncident;
    const newIsRenderIncident = wasOpen ? !this.state.isrenderIncident : this.state.isrenderIncident;
   this.setState(
        { 
            showIncident: !this.state.showIncident,
            isrenderIncident: newIsRenderIncident,
        }, 
        async () => {
          if(wasOpen){
            this.getIncidentBodyPartChange()
          }
            // await this.getIncidentById();
        }
    );
};
  addVaccineToogleHandler=(form_id='')=>{
    this.setState({isVaccineModelOpen:!this.state.isVaccineModelOpen,form_id:form_id,activeEditId:form_id==""?"":this.state.activeEditId});
  }
 setActiveEditId=(id)=>{
    this.setState({activeEditId:id})
  } 
  render() {
    const visit_id = this.props.params.visitId;
    const { employeeId,showIncident, visitDetails, employeeDetails ,selectedBodyPart,AddLabToggle, isPatientPopoverOpen, isInjuryPopoverOpen, isCompanyPopoverOpen, isLeftSidebarCollapsed } = this.state;
    const { location, navigate, Toast, Loader } = this.props;
    const fromPage = location.state?.from;
    const visit_category = visitDetails["0"]?.visit_category;
    const isTablet = this.isTabletWidth();
    const isDesktopLarge = this.isDesktopLarge();
    const patientName = `${employeeDetails?.first_name || ""} ${employeeDetails?.last_name || ""}`.trim();
    const patientDob = employeeDetails?.dob || "";
    const patientId = employeeDetails?.patient_id || "";
    const patientPhone = employeeDetails?.phone ? formatPhoneNumberUS(employeeDetails.phone) : "";
  
    
    return (
      <>
      {(showIncident && (visit_category==="Work Comp - New Injury" || visit_category==="Work Comp - Follow Up" || visit_category==="Work Comp - Physical Therapy" || visit_category==="Work Comp - Other" ||
        visit_category==="Urgent Care - Injury" || visit_category==="Urgent Care - Illness" || visit_category==="Urgent Care - Follow Up" || visit_category==="Urgent Care - Cash Patient" || visit_category==="Urgent Care - Telehealth" ||
        visit_category==="Private - Mental Health Exam" || visit_category==="Private - Primary Care - Initial" || visit_category==="Private - Primary Care - Follow Up")) &&
      <AddIncidentModal incidentToogleHandler = {this.incidentToogleHanlder} isOpen={showIncident} visitId={visit_id} employeeDetails={employeeDetails} isEdit={true} selectedBodyPart={selectedBodyPart}           setSelectedBodyPart={(val) => {
        console.log("✅ setSelectedBodyPart called with value:", val);
        this.setState({ selectedBodyPart: val, isrenderICD: val });
      }} visitCategory={visit_category}
      
        />
      }
      {/* { AddLabToggle &&
          <NewAddLab
            modelTitle={"Add Lab"}
            isOpen={true}
            visitId={visit_id}
            mapping_id={null}
            modalToogleHandler={this.ToggleOrders}
            fetchRecords={() => {this.setState(({renderResults:!this.state.renderResults})) }}
            fromChart={false}
            activeEditId={this.state.activeEditId}
            form_id={this.state.form_id}
          />
      }
        {this.state.isVaccineModelOpen &&
          <NewAddVaccine
            modelTitle={"Add Vaccine"}
            isOpen={true}
            visitId={visit_id}
            mapping_id={null}
            modalToogleHandler={this.addVaccineToogleHandler}
            fetchRecords={() => {this.setState(({renderResults:!this.state.renderResults})) }}
            fromChart={false}
            activeEditId={this.state.activeEditId}
            form_id={this.state.form_id}
          />
      } */}
      <div className="sh_cardBox">
          <BreadCrumbs visit_category={visit_category}
            employeeDetails={employeeDetails}
            visitDetails={visitDetails}
            visitStatus={this.state.visit_status}
            timelineData={this.state.timelineData}
            visit_id={this.props.params.visitId}
            fetchVisitList={this.fetchVisitList}
            Loader={Loader}
            Toast={Toast}
            onOpenSendMessageFromCharting={this.openSendMessageFromCharting}
          />

          {isTablet ? (
            <div className="sh_emrStickyPatientBar">
              <div className="sh_emrStickyPatientBarLeft">
                <span className="sh_emrStickyPatientAvatar" aria-hidden="true">
                <svg width="24" height="24" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.8001 16.7996C15.2601 16.7996 13.9418 16.2513 12.8451 15.1546C11.7484 14.0579 11.2001 12.7396 11.2001 11.1996C11.2001 9.65961 11.7484 8.34128 12.8451 7.24461C13.9418 6.14794 15.2601 5.59961 16.8001 5.59961C18.3401 5.59961 19.6584 6.14794 20.7551 7.24461C21.8518 8.34128 22.4001 9.65961 22.4001 11.1996C22.4001 12.7396 21.8518 14.0579 20.7551 15.1546C19.6584 16.2513 18.3401 16.7996 16.8001 16.7996ZM8.4001 27.9996C7.6301 27.9996 6.97116 27.7257 6.4233 27.1778C5.8745 26.629 5.6001 25.9696 5.6001 25.1996V24.0796C5.6001 23.2863 5.8045 22.5569 6.2133 21.8914C6.62116 21.2269 7.16343 20.7196 7.8401 20.3696C9.28676 19.6463 10.7568 19.1035 12.2501 18.7414C13.7434 18.3802 15.2601 18.1996 16.8001 18.1996C18.3401 18.1996 19.8568 18.3802 21.3501 18.7414C22.8434 19.1035 24.3134 19.6463 25.7601 20.3696C26.4368 20.7196 26.979 21.2269 27.3869 21.8914C27.7957 22.5569 28.0001 23.2863 28.0001 24.0796V25.1996C28.0001 25.9696 27.7262 26.629 27.1783 27.1778C26.6295 27.7257 25.9701 27.9996 25.2001 27.9996H8.4001ZM8.4001 25.1996H25.2001V24.0796C25.2001 23.8229 25.1362 23.5896 25.0083 23.3796C24.8795 23.1696 24.7101 23.0063 24.5001 22.8896C23.2401 22.2596 21.9684 21.7869 20.6851 21.4714C19.4018 21.1569 18.1068 20.9996 16.8001 20.9996C15.4934 20.9996 14.1984 21.1569 12.9151 21.4714C11.6318 21.7869 10.3601 22.2596 9.1001 22.8896C8.8901 23.0063 8.72116 23.1696 8.5933 23.3796C8.4645 23.5896 8.4001 23.8229 8.4001 24.0796V25.1996ZM16.8001 13.9996C17.5701 13.9996 18.2295 13.7252 18.7783 13.1764C19.3262 12.6285 19.6001 11.9696 19.6001 11.1996C19.6001 10.4296 19.3262 9.77068 18.7783 9.22281C18.2295 8.67401 17.5701 8.39961 16.8001 8.39961C16.0301 8.39961 15.3712 8.67401 14.8233 9.22281C14.2745 9.77068 14.0001 10.4296 14.0001 11.1996C14.0001 11.9696 14.2745 12.6285 14.8233 13.1764C15.3712 13.7252 16.0301 13.9996 16.8001 13.9996Z" fill="#4A505C"></path></svg>
                </span>
                <div className="sh_emrStickyPatientText">
                  <span className="sh_emrStickyPatientName">{patientName}</span>
                  <span className="sh_emrStickyPatientMeta">
                    {patientDob ? `DOB: ${patientDob}` : ""}
                    {patientId ? `  |  ID: ${patientId}` : ""}
                    {patientPhone ? `  |  Phone: ${patientPhone}` : ""}
                  </span>
                </div>
              </div>

              <div className="sh_emrStickyPatientBarRight">
                <button
                  ref={this.patientBtnRef}
                  type="button"
                  className="btn  btn-primary"
                  onClick={() =>
                    this.setState((prev) => ({
                      isPatientPopoverOpen: !prev.isPatientPopoverOpen,
                    }))
                  }
                >
                  Patient 
                </button>

                <button
                  ref={this.injuryBtnRef}
                  type="button"
                  className="btn  btn-primary ml-2"
                  onClick={() =>
                    this.setState((prev) => ({
                      isInjuryPopoverOpen: !prev.isInjuryPopoverOpen,
                    }))
                  }
                >
                  Injury 
                </button>

                <button
                  ref={this.companyBtnRef}
                  type="button"
                  className="btn  btn-primary ml-2"
                  onClick={() =>
                    this.setState((prev) => ({
                      isCompanyPopoverOpen: !prev.isCompanyPopoverOpen,
                    }))
                  }
                >
                  Company 
                </button>
                
                
              </div>

              <div
                ref={this.patientPopoverRef}
                className={`sh_emrStickyPopover ${isPatientPopoverOpen ? "open" : ""}`}
                style={{ left: 0 }}
              >
                <div className="sh_emrStickyPopoverInner">
                  <NewPatientDetails
                    visit_id={visit_id}
                    employeeId={employeeId}
                    employeeDetails={employeeDetails}
                    fetchEmployeeDetails={this.fetchEmployeeDetails}
                  />
                </div>
              </div>

              <div
                ref={this.injuryPopoverRef}
                className={`sh_emrStickyPopover ${isInjuryPopoverOpen ? "open" : ""}`}
                style={{ left: "auto" }}
              >
                <div className="sh_emrStickyPopoverInner">
                  <OrganSection
                    incidentToogleHanlder={this.incidentToogleHanlder}
                    visit_category={visit_category}
                    selectedBodyPart={selectedBodyPart}
                    handleEvent={this.handleEvent}
                    incidentDetails={this.state.incidentDetails}
                    setSelectedBodyPart={(val) => this.setState({ selectedBodyPart: val, isrenderICD: val })}
                  />
                </div>
              </div>

              <div
                ref={this.companyPopoverRef}
                className={`sh_emrStickyPopover ${isCompanyPopoverOpen ? "open" : ""}`}
                style={{ left: "auto" }}
              >
                <div className="sh_emrStickyPopoverInner">
                  <CompanyDetails companyDetails={employeeDetails?.company} />
                </div>
              </div>
            </div>
          ) : null}

          <div className="sh_cardBody py-1">
            <div className="row sh_emrSidebarRowWrap" >
              {isDesktopLarge ? (
                <button
                  type="button"
                  className={`btn sh_btniconnew sh_emrSidebarEdgebtnToggle ${isLeftSidebarCollapsed ? "is-collapsed" : ""}`}
                  onClick={() => this.setState((prev) => ({ isLeftSidebarCollapsed: !prev.isLeftSidebarCollapsed }))}
                  title={isLeftSidebarCollapsed ? "Expand widgets" : "Collapse widgets"}
                  aria-label={isLeftSidebarCollapsed ? "Expand left sidebar" : "Collapse left sidebar"}
                >
                  {isLeftSidebarCollapsed ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      width="12px"
                      height="12px"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="m5.25 4.5 7.5 7.5-7.5 7.5m6-15 7.5 7.5-7.5 7.5"
                      />
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      width="12px"
                      height="12px"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="m18.75 4.5-7.5 7.5 7.5 7.5m-6-15L5.25 12l7.5 7.5"
                      />
                    </svg>
                  )}
                </button>
              ) : null}
              <div className={`px-2 sh_emrLeftSidebarCol ${isLeftSidebarCollapsed ? "is-collapsed" : ""}`} style={{width: '20%'}}>
                <NewPatientDetails 
                  visit_id={visit_id}
                  employeeId={employeeId}
                  employeeDetails={employeeDetails}
                  fetchEmployeeDetails={this.fetchEmployeeDetails} />
              <OrganSection 
                incidentToogleHanlder={this.incidentToogleHanlder}  
                visit_category={visit_category} 
                selectedBodyPart={selectedBodyPart}
                handleEvent={this.handleEvent}
                incidentDetails={this.state.incidentDetails}
                // organList={this.getOrganList()}
                setSelectedBodyPart={(val) =>
                  this.setState({ selectedBodyPart: val, isrenderICD: val })}  />
                                  <NewProviderDetails
                  visitDetails={visitDetails}
                  visit_id={visit_id}
                  fetchVisitDetails={this.fetchVisitList}
                />
              {/* <AIPrediction
                incidentDetails={this.state.incidentDetails}
                Toast={Toast}
                visitId={visit_id}
                organizationId={visitDetails["0"]?.organization_id || visitDetails["0"]?.organization?.organization_uuid}
                onSuggestionAccepted={() => {
                  // Trigger assessment refresh
                  this.setState((prev) => ({
                    assessmentRefreshTrigger: prev.assessmentRefreshTrigger + 1
                  }));
                }}
                aiSuggestionsRefreshTrigger={this.state.aiSuggestionsRefreshTrigger}
                onEmrSave={true}
              /> */}
              </div>
              <div className={`sh_emrMainContentCol px-0 ${isLeftSidebarCollapsed ? "sh_emrMainContentColExpanded" : ""}`}>
                <NewRightContent
                  Loader={Loader}
                  visit_id={visit_id}
                  employeeId={employeeId}
                  Toast={Toast}
                  visitDetails={visitDetails}
                  employeeDetails={employeeDetails}
                  fetchEmployeeDetails={this.fetchEmployeeDetails}
                  selectedBodyPart={this.state.selectedBodyPart}
                  isrenderICD={this.state.isrenderICD}
                  isrenderIncident={this.state.isrenderIncident}
                  setSelecetedBodyParts={(selected)=>this.setState({selectedBodyPart:selected})}
                  ToggleOrders={this.ToggleOrders}
                  addVaccineToogleHandler={this.addVaccineToogleHandler}
                  renderResults={this.state.renderResults}
                  onDiagnosisRemoved={() => {
                    // Trigger AI suggestions refresh
                    this.setState((prev) => ({
                      aiSuggestionsRefreshTrigger: prev.aiSuggestionsRefreshTrigger + 1
                    }));
                  }}
                  activeEditId={this.state.activeEditId}
                  setActiveEditId={this.setActiveEditId}
                  visit_status={this.state.visit_status}
                  setVisitStatus={(val)=>this.setState({visit_status:val})}
                  getIncidentById={this.getIncidentById}
                  incidentDetails={this.state.incidentDetails} // <-- ADDED: Pass incident details down
                  assessmentRefreshTrigger={this.state.assessmentRefreshTrigger} // Pass trigger to refresh assessment
                  onHpiSaved={async () => {}}
                  profile={this.props.profile}
                  fetchVisitList={this.fetchVisitList}
                  isLeftSidebarCollapsed={isLeftSidebarCollapsed}
                />
              </div>
          </div>
          </div>
        </div>
        {this.state.chartingSendMessageOpen && (
          <SendTaskModal
            isOpen={this.state.chartingSendMessageOpen}
            modalToogleHandler={this.closeSendMessageFromCharting}
            Toast={Toast}
            Loader={Loader}
            navigationLink={this.state.chartingSendMessageNav}
          />
        )}
      </>
    );
  }
  fetchVisitList = async (visitId = this.props.params.visitId) => {
    const { Loader, Toast } = this.props;
    Loader(true);
    try {
      const data = await VisitsService.getVisits(visitId);
      this.setState({
        visitDetails: { ...data[0], ...data },
        employeeId: data[0].employee_id,
        visit_status: data[0].visit_status || '', 
      });
      
      // Deleted activities are handled silently - no toast notification
      
      Loader(false);
    } catch (error) {
      Loader(false);
      console.error("Error fetching employee details:", error);
    }
  };
  fetchEmployeeDetails = async (employeeId) => {
    const { Loader } = this.props;
    try {
      if (employeeId) {
        Loader(true);
        const data = await EmployeeService.getEmployee(employeeId);
        this.setState({ employeeDetails: data });
        Loader(false);
      }
    } catch (error) {
      Loader(false);
      console.error("Error fetching employee details:", error);
    }
  };
  getIncidentById=async()=>{
    try{
      console.log('fetching incident details for visit id:',this.props.params.visitId);
       const response = await IncidentService.getIncidentById(this.props.params.visitId);
       this.setState({ incidentDetails: response});
       if (response.injury_locations && response.injury_locations.trim() !== "") {
        this.setState((prevState) => ({
          selectedBodyPart: [
            ...prevState.selectedBodyPart,
            response.injury_locations.trim(),
          ],
        }));
      }
       console.log("bodypartt",this.state.selectedBodyPart);
    }catch(err){
      console.error('Error fetching incident details:', err);
    }finally{
      
    }
  }
  fetchTimeline = async () => {
    try {
      const visitId = this.props.params.visitId;
      const timelineData = await VisitsService.getVisitTimeLine(visitId);
      console.log('timelineData',timelineData);
      if (timelineData && Array.isArray(timelineData)) {
        this.setState({ timelineData });
      }
    } catch (error) {
      console.error("Error fetching timeline:", error);
    }
  };
}


const mapStateToProps = (state) => {
  const profileId = isSet(AuthService.getProfileId(), null);
  return {
    stateList: state.session.profileStateList,
    profile: profileId !== null ? state.session.profileDetails?.[profileId] ?? {} : {},
  };
};

// Connect the component to Redux store
export default connect(mapStateToProps)(
  WithRouter(WithRoutify(NewEmrDetailView))
);

//  export default WithRouter(WithRoutify(EmrVistDetailView));
